import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import {useInfiniteQuery} from 'react-query'
import {parseProductsDropdown} from '../parsings'
import {useParams} from 'react-router-dom'

const useGetProductsDropdown = () => {
  const Api = useApi()
  const {id} = useParams()
  const initialFilters = {
    page: 1,
    limit: 10,
    search: '',
    badge_id: id,
  }
  const {filters, onSearch} = useFilters(initialFilters)
  const getProducts = async ({pageParam = 1}) => {
    const response = await Api.get('/products/product-badges/all-products/dropdown', {
      filters: {...filters, page: pageParam},
      isToast: false,
      isErrorPageRedirection: false,
    })
    return response
  }

  const {data, fetchNextPage, hasNextPage, isFetching, refetch} = useInfiniteQuery(
    ['products-dropdown', filters],
    getProducts,
    {
      getNextPageParam: (lastPage) => lastPage?.meta?.next_page || undefined,
    }
  )

  const onLoadMore = () => {
    if (hasNextPage) fetchNextPage()
  }

  // Flatten all loaded products and parse them
  const allProducts = parseProductsDropdown(data?.pages?.flatMap((page) => page?.data) || [])
  // Use meta from the last loaded page
  const productPagination = data?.pages?.[data.pages.length - 1]?.meta || {}

  return {
    allProducts,
    isLoading: isFetching,
    productPagination,
    onSearchProducts: onSearch,
    onPageChangeProducts: onLoadMore,
    refetchProducts: refetch,
  }
}

export default useGetProductsDropdown
